import React, { useState } from 'react';
import Box from "@mui/material/Box";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { actionMenuStyle, iconStyle } from './OptionsMenu.style';
import { MenuContent } from './Menu';
import { Drawer } from './Drawer';
import { Button } from '../Button';
export var MenuType;
(function (MenuType) {
    MenuType["MENU"] = "menu";
    MenuType["DRAWER"] = "drawer";
})(MenuType || (MenuType = {}));
export const OptionsMenu = ({ dataQa, id, actions, drawer, buttonVariant, buttonColor, type = MenuType.MENU, buttonSx }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpened = Boolean(anchorEl);
    const openMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const hasOneAction = actions.length === 1;
    return (React.createElement(Box, null,
        React.createElement(Button, { onClick: (event) => hasOneAction ? actions[0].action(id) : openMenu(event), "data-qa": `${dataQa}-actionButton`, variant: buttonVariant || "text", color: buttonColor || "tertiary", sx: actionMenuStyle(isOpened, buttonSx, buttonColor, buttonVariant) }, hasOneAction
            ? React.createElement(React.Fragment, null, actions[0].icon)
            : React.createElement(MoreHorizIcon, { sx: iconStyle })),
        type === MenuType.MENU && (React.createElement(MenuContent, { dataQa: dataQa, id: id, actions: actions, isOpened: isOpened, anchorEl: anchorEl, setAnchorEl: setAnchorEl })),
        type === MenuType.DRAWER && (React.createElement(Drawer, { dataQa: dataQa, id: id, actions: actions, isOpened: isOpened, drawer: drawer, setAnchorEl: setAnchorEl }))));
};
